import { useEffect } from "react";

/**
 * Sets window.__PAGE_READY__ = true once the page data is loaded and all
 * images are complete. Used by the PDF Lambda to know when to capture the page.
 *
 * themeFontSpecs are force-loaded via document.fonts.load() since document.fonts.ready alone can resolve before a themed font is queued.
 */
export const usePageReadySignal = (props: {
  isReadyToCapture: boolean;
  themeFontSpecs?: string[];
}) => {
  const { isReadyToCapture, themeFontSpecs = [] } = props;
  useEffect(() => {
    if (!isReadyToCapture) return;

    let interval: ReturnType<typeof setInterval>;

    Promise.all([
      document.fonts.ready,
      ...themeFontSpecs.map((spec) =>
        document.fonts.load(spec).catch(() => undefined),
      ),
    ]).then(() => {
      interval = setInterval(() => {
        const images = Array.from(document.querySelectorAll("img"));
        const allComplete = images.every((img) => img.complete);
        if (allComplete) {
          clearInterval(interval);
          window.__PAGE_READY__ = true;
        }
      }, 100);
    });

    return () => clearInterval(interval);
  }, [isReadyToCapture, themeFontSpecs]);
};
